import React, { Component } from 'react'

export default function CartColumns() {
        return (
            <div className="container-fluid text-center d-none d-lg-block">
                <div className="row">
                    <div className="col-10 mx-auto col-lg-2">
                    <p className="text-uppercase" style={{fontSize:'2rem'}}> products </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-2">
                    <p className="text-uppercase" style={{fontSize:'2rem'}}> item name </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-2">
                    <p className="text-uppercase" style={{fontSize:'2rem'}}> price </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-2">
                    <p className="text-uppercase" style={{fontSize:'2rem'}}> quantity </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-2">
                    <p className="text-uppercase" style={{fontSize:'2rem'}}> remove </p>
                    </div>
                    <div className="col-10 mx-auto col-lg-2">
                    <p className="text-uppercase" style={{fontSize:'2rem'}}> total </p>
                    </div>
                </div>
            </div>
        )
    }
